<script lang="ts">import { browser } from "$app/environment";
const prodHosts = ["turboslot.com", "www.turboslot.com"];
const showSeal = browser && prodHosts.includes(window.location.hostname);
</script>

{#if showSeal}
	<iframe
		title="Seal"
		src="/seal-turbo.htm"
		style="height: 48px; width: 48px; border: none; display: block;"
	></iframe>
{/if}
